
window.isError = false
import './core/render'
import '@/styles/index.less'
import { addGlobalUncaughtErrorHandler } from 'qiankun'
import microAppStart from './core/auth'


addGlobalUncaughtErrorHandler((event) => {
  const { message } = event
  if(message && message.indexOf('died in status LOADING_SOURCE_CODE') !=-1) {
    window.isError = true
  }else {
    if(!window.isError) {
      microAppStart()
    }
  }
});
if((location.href.indexOf('/') !=-1 && location.href.split('/').length<=4) || location.href.indexOf('/')==-1) {
    microAppStart()
}